var BackgroundColorsEnum;
(function (BackgroundColorsEnum) {
    BackgroundColorsEnum["banner1"] = "banner1";
    BackgroundColorsEnum["banner2"] = "banner2";
    BackgroundColorsEnum["banner3"] = "banner3";
    BackgroundColorsEnum["banner4"] = "banner4";
    BackgroundColorsEnum["banner5"] = "banner5";
    BackgroundColorsEnum["banner6"] = "banner6";
    BackgroundColorsEnum["banner7"] = "banner7";
    BackgroundColorsEnum["banner8"] = "banner8";
    BackgroundColorsEnum["primaryBase"] = "primaryBase";
    BackgroundColorsEnum["secondaryBase"] = "secondaryBase";
    BackgroundColorsEnum["statusNegative"] = "statusNegative";
    BackgroundColorsEnum["statusPositive"] = "statusPositive";
    BackgroundColorsEnum["statusWarning"] = "statusWarning";
    BackgroundColorsEnum["tertiaryBase"] = "tertiaryBase";
    BackgroundColorsEnum["transparent"] = "transparent";
})(BackgroundColorsEnum || (BackgroundColorsEnum = {}));
function getBgColorClass(bgColor) {
    switch (bgColor) {
        case 'banner1':
            return 'bg-banner1';
        case 'banner2':
            return 'bg-banner2';
        case 'banner3':
            return 'bg-banner3';
        case 'banner4':
            return 'bg-banner4';
        case 'banner5':
            return 'bg-banner5';
        case 'banner6':
            return 'bg-banner6';
        case 'banner7':
            return 'bg-banner7';
        case 'banner8':
            return 'bg-banner8';
        case 'primaryBase':
            return 'bg-primary-base';
        case 'secondaryBase':
            return 'bg-secondary-base';
        case 'statusNegative':
            return 'bg-status-negative';
        case 'statusPositive':
            return 'bg-status-positive';
        case 'statusWarning':
            return 'bg-status-warning';
        case 'tertiaryBase':
            return 'bg-tertiary-base';
        case 'transparent':
            return 'bg-transparent';
        default:
            return '';
    }
}

export { BackgroundColorsEnum, getBgColorClass };
//# sourceMappingURL=bgColors.js.map
